<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
@if (definition) {
  <div fxLayout="column" fxLayoutAlign="start stretch" fxFlex>
    @if (dataSource?.hasHtml$ | async) {
      <div class="selectable-text"
        fxLayout="column" fxLayoutAlign="space-between start" fxFlexAlign="stretch"
        style="flex: 1 1 auto;"
      [innerHTML]="dataSource?.reportHtml"></div>
    } @else {
      <div class="table-container" fxFlex fxFlexAlign="stretch">
        <table mat-table [dataSource]="dataSource">
          @if (definition.totalFields) {
            <td mat-footer-cell *matFooterCellDef>Totals:</td>
          }
          @if (definition.averageFields) {
            <td mat-footer-cell *matFooterCellDef>Averages:</td>
          }
          @for (field of definition.fields; track field; let i = $index) {
            <ng-container [matColumnDef]="field.name">
              <th mat-header-cell *matHeaderCellDef>{{ field.display }}</th>
              <td mat-cell *matCellDef="let row"
                [style.max-width]="field.maxWidth || ''"
                [style.min-width]="field.minWidth || ''"
                [class.no-wrap]="!field.wrap">
                <dash-gis-base-field [fieldDefinition]="field" [rowData]="row"
                [tableEditActive]="false"></dash-gis-base-field>
              </td>
            </ng-container>
          }
          <!-- totals -->
          @for (fieldName of columnsToDisplay; track fieldName; let i = $index) {
            <ng-container
              [matColumnDef]="'total_' + fieldName">
              @if (definition.totalFields) {
                @switch (getTotalsCellDisplay(fieldName, i)) {
                  @case ('label') {
                    <td mat-footer-cell *matFooterCellDef>Totals:</td>
                  }
                  @case ('value') {
                    <td mat-footer-cell *matFooterCellDef>
                      {{ getTotalsValue$(fieldName) | async | number: '1.2' }}
                    </td>
                  }
                  @default {
                    <td mat-footer-cell *matFooterCellDef></td>
                  }
                }
                @if (!definition.enableZoom && i === 0) {
                  <td mat-footer-cell *matFooterCellDef>Totals:</td>
                }
              }
            </ng-container>
          }
          <!-- averages -->
          @for (fieldName of columnsToDisplay; track fieldName; let i = $index) {
            <ng-container
              [matColumnDef]="'average_' + fieldName">
              @if (definition.averageFields) {
                @switch (getAveragesCellDisplay(fieldName, i)) {
                  @case ('label') {
                    <td mat-footer-cell *matFooterCellDef>Averages:</td>
                  }
                  @case ('value') {
                    <td mat-footer-cell *matFooterCellDef>
                      {{ getAveragesValue$(fieldName) | async | number: '1.2' }}
                    </td>
                  }
                  @default {
                    <td mat-footer-cell *matFooterCellDef></td>
                  }
                }
                @if (!definition.enableZoom && i === 0) {
                  <td mat-footer-cell *matFooterCellDef>Averages:</td>
                }
              }
            </ng-container>
          }
          <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
          <tr mat-row *matRowDef="let rowData; columns: columnsToDisplay"></tr>
          @if (definition.totalFields) {
            <tr mat-footer-row *matFooterRowDef="totalsColumnsToDisplay"></tr>
          }
          @if (definition.averageFields) {
            <tr mat-footer-row *matFooterRowDef="averagesColumnsToDisplay"></tr>
          }
        </table>
      </div>
    }
  </div>
}



